import * as React from 'react'
import classnames from 'classnames'
import { Button, Grid, Anchor } from '@design-systems/canvas-ui'
import { useNavigate, useLocation } from 'react-router-dom'
import { constants } from './constants'
import './styles.css'
import { TgtLogger } from '@measurement/opentelemetry-web'
import { useAuth, useEntitlements } from 'properties-ui-common'
interface UnauthorizedProps {}

export const Unauthorized: React.FC<UnauthorizedProps> = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const auth = useAuth()
  const { entitlements } = useEntitlements()
  const isPolUser = entitlements?.pol?.read
  const isPolQmsUser = entitlements?.qms?.pol
  const isPolNriAllowed = entitlements?.nri?.pol
  const { unauthorizedRoute = '' } = location?.state ?? {}

  React.useEffect(() => {
    TgtLogger.warn('unauthorized-access-attempt', {
      error: {
        message: `Unauthorized access attempt was made to: ${unauthorizedRoute}`,
      },
      user: {
        name: auth?.session?.userInfo?.lanId,
      },
      nonIndexedFields: {
        isPolUser,
        isPolQmsUser,
        isPolNriAllowed,
        referrer: document.referrer || 'direct',
        timestamp: new Date().toISOString(),
      },
    })
  }, [
    auth?.session,
    isPolUser,
    isPolQmsUser,
    isPolNriAllowed,
    unauthorizedRoute,
  ])

  return (
    <Grid.Container justify="center" className="container">
      <Grid.Item>
        <div className="hc-pa-normal">
          <div>
            <div className="hc-fs-xl">
              {constants.unAuthorized_text_1} {constants.unAuthorized_text_2}
            </div>
            <div className={classnames('hc-fs-md', 'hc-ta-center')}>
              <Anchor className="C-Anchor" href={unauthorizedRoute}>
                {unauthorizedRoute}
              </Anchor>
            </div>
          </div>
          <div className="buttonDiv">
            <Button
              variant="primary"
              size="lg"
              title={constants.unAuthorized_button_1}
              onClick={() => navigate('/')}
            >
              {constants.unAuthorized_button_1}
            </Button>
            <Button
              className="hc-ml-lg"
              size="lg"
              variant="primary"
              title={constants.unAuthorized_button_2}
              onClick={() => navigate(-1)}
            >
              {constants.unAuthorized_button_2}
            </Button>
          </div>
        </div>
      </Grid.Item>
    </Grid.Container>
  )
}

export default Unauthorized
